function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.455 13.82V9.274a5.455 5.455 0 10-10.91 0v4.546a3.62 3.62 0 01-.486 1.819h11.882a3.62 3.62 0 01-.486-1.819zm3.636 3.637H2.909c-1.212 0-1.212-1.818 0-1.818a1.818 1.818 0 001.818-1.819V9.274a7.273 7.273 0 1114.546 0v4.546c0 1.004.814 1.819 1.818 1.819 1.212 0 1.212 1.818 0 1.818zm-6.732 3.184a2.727 2.727 0 01-4.718 0 .91.91 0 01.786-1.365h3.146c.7 0 1.138.759.786 1.365z"
});

var SvgBell = function SvgBell(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/bell.6cdaa58d.svg";
export { SvgBell as ReactComponent };